import Text from 'components/Text'
import isNil from 'lodash/isNil'
import * as React from 'react'
import styled from 'styled-components'

import {
  inputColumnContainer,
  inputContainerDescription,
  inputContainerMagicAlign,
  inputContainerMargin
} from './style'

type PropsType = {
  children: React.ReactNode
  className?: string
  description?: string
  horizontal?: boolean
  margin?: string
}

const Column = styled.div`
  display: flex;
  flex: 1 1 50%;
`

const Description = styled(Text)`
  margin-top: 0.5rem;
`

const Wrapper = styled.div`
  position: relative;
  ${({ horizontal }: PropsType) => (horizontal ? inputContainerMagicAlign : '')};
  ${({ horizontal, length }: PropsType & { length: number }) =>
    length > 1 && !horizontal ? inputColumnContainer : inputContainerMargin};
  ${({ description }: PropsType) => (isNil(description) ? '' : inputContainerDescription)};
`

const InputContainer = ({
  children,
  className,
  description,
  horizontal,
  margin,
  ...rest
}: PropsType) => {
  const { length } = React.Children.toArray(children)

  return (
    <Wrapper
      className={className}
      description={description}
      horizontal={horizontal}
      length={length}
      margin={margin}
      {...rest}
    >
      {!isNil(description) && (
        <>
          <Column>
            {children}
            <Description color='dark300' size='xs'>
              {description}
            </Description>
          </Column>
        </>
      )}
      {isNil(description) && children}
    </Wrapper>
  )
}

export default InputContainer
